module.exports = __webpack_public_path__ + "static/media/sony-alpha.1c8404df.svg";